import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/esnext.iterator.some.js";
import { getMessagesKeyFirstPartRemoved, getValueByDotNotation, isFunction, isObject, MOA } from "./mcn-helpers";
import findIndex from "lodash-es/findIndex";
import store from "../../store";
import Model from "../../views/dashboard/models/Model";
import UrlManager from "./UrlManager";
import { get } from "lodash-es";
import JsonMappedModel from "./models/helpers/JsonMappedModel";
export default class Form extends UrlManager {
  getFormMode() {
    return this.mode.content;
  }
  isOnEditMode() {
    return this.mode.content === Form.EDIT_MODE;
  }
  isCreateMode() {
    return this.mode.content === Form.CREATE_MODE;
  }
  setMode(mode) {
    this.mode.content = mode;
    Object.keys(this).forEach(key => this[key].content instanceof Form && this[key].content.setMode(mode));
    return this;
  }
  makeEditMode() {
    this.setMode(Form.EDIT_MODE);
    return this;
  }
  makeCreateMode() {
    this.setMode(Form.CREATE_MODE);
    return this;
  }
  setOnEditMode() {
    this.setMode(Form.EDIT_MODE);
    Object.keys(this).forEach(key => {
      var _this$key$content, _this$key;
      let fieldContent = (_this$key$content = (_this$key = this[key]) === null || _this$key === void 0 ? void 0 : _this$key.content) !== null && _this$key$content !== void 0 ? _this$key$content : null;
      if (Array.isArray(fieldContent)) {
        return fieldContent.forEach(fieldContentForm => fieldContentForm instanceof Form && fieldContentForm.setOnEditMode());
      }
      if (fieldContent instanceof Form) {
        return fieldContent.setOnEditMode();
      }
    });
    return this;
  }
  toggleFieldShowMore() {
    this.fieldShowMore.content = !this.fieldShowMore.content;
    return this;
  }
  isShowMoreActive() {
    return this.fieldShowMore.content;
  }
  canShowField(field) {
    let fields = Object.keys(this).filter(fieldKey => this[fieldKey].enumerable !== false);
    let index = findIndex(fields, key => this[key].id === field.id);
    return index > this.fieldShowMore.fieldsVisibleCount - 1 ? this.fieldShowMore.content : true;
  }
  initForm() {
    this.emptyFormFields().emptyGlobalMessages().emptyValidationMessages();
    return this;
  }
  startDeleteLoading() {
    this.loading.delete = true;
    return this;
  }
  endDeleteLoading() {
    this.loading.delete = false;
    return this;
  }
  startCreateLoading() {
    this.loading.create = true;
    return this;
  }
  startListLoading() {
    this.loading.list = true;
    return this;
  }
  isListLoading() {
    return this.loading.list;
  }
  endListLoading() {
    this.loading.list = false;
    return this;
  }
  startDuplicateLoading() {
    this.loading.duplicate = true;
    return this;
  }
  endDuplicateLoading() {
    this.loading.duplicate = false;
    return this;
  }
  endCreateLoading() {
    this.loading.create = false;
    return this;
  }
  isCreateLoading() {
    return this.loading.create;
  }
  isDeleteLoading() {
    return this.loading.delete;
  }
  isDuplicateLoading() {
    return this.loading.duplicate;
  }
  startSaveLoading() {
    this.loading.save = true;
    return this;
  }
  endSaveLoading() {
    this.loading.save = false;
    return this;
  }
  isSaveLoading() {
    return this.loading.save;
  }
  setSnackMessage(message, type) {
    this.snackMessage.content = message;
    this.snackMessage.type = type;
    this.snackMessage.open = true;
  }
  setSuccessSnackMessage(message) {
    this.setSnackMessage(message, 'success');
  }
  setErrorSnackMessage(message) {
    this.setSnackMessage(message, 'error');
  }
  emptyGlobalMessages() {
    this.globalMessage.content = null;
    this.globalMessage.name = null;
    this.globalMessage.type = null;
    return this;
  }
  setGlobalMessage(message, type) {
    this.globalMessage.content = message;
    this.globalMessage.type = type;
  }
  getGlobalMessage() {
    return this.globalMessage;
  }
  getGlobalMessageType() {
    return this.globalMessage.type;
  }
  hasGlobalMessage() {
    var _this$globalMessage$c;
    return ((_this$globalMessage$c = this.globalMessage.content) === null || _this$globalMessage$c === void 0 ? void 0 : _this$globalMessage$c.length) > 0;
  }
  getGlobalMessageMessage() {
    return this.globalMessage.content;
  }
  setGlobalSuccessMessage(message) {
    this.setGlobalMessage(message, 'success');
    return this;
  }
  setGlobalErrorMessage(message) {
    this.setGlobalMessage(message, 'error');
    return this;
  }
  constructor() {
    super();
    _defineProperty(this, "mode", {
      enumerable: false,
      content: Form.CREATE_MODE,
      default() {
        // keep this function so emptyFormFields doesn't reset the content to null
      },
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "globalMessage", {
      enumerable: false,
      toForm: false,
      type: null,
      content: null,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "snackMessage", {
      enumerable: false,
      close: true,
      open: false,
      type: null,
      content: null,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "fieldShowMore", {
      fieldsVisibleCount: 2,
      enumerable: false,
      content: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
    _defineProperty(this, "loading", {
      enumerable: false,
      create: false,
      save: false,
      duplicate: false,
      delete: false,
      list: false,
      isVisible() {
        return this.enumerable !== false;
      }
    });
  }
  deepFieldsValidation(messages) {
    if (!isObject(this)) return;
    Object.keys(this).forEach(k => MOA(this[k], messages));
    return this;
  }
  emptyValidationMessages() {
    Object.keys(this).forEach(key => {
      if (!isObject(this[key]) || !this[key].hasOwnProperty('content')) {
        return;
      }
      if (this[key].content instanceof Form) {
        this[key].content.emptyValidationMessages();
        return;
      }
      if (Array.isArray(this[key].content)) {
        this[key].content.forEach(item => {
          if (!(item instanceof Form)) {
            return;
          }
          item.emptyValidationMessages();
        });
      }
      if (!this[key].hasOwnProperty('messages')) {
        return;
      }
      this[key].messages = [];
    });
    return this;
  }
  getDeepValidationMessages() {
    return Object.keys(this).reduce((init, key) => {
      var _this$key$messages;
      return init.concat(this[key].content instanceof Form ? this[key].content.getDeepValidationMessages() : (_this$key$messages = this[key].messages) !== null && _this$key$messages !== void 0 ? _this$key$messages : []);
    }, []);
  }
  setValidationMessages(messages) {
    if (!messages) {
      return this;
    }
    Object.keys(this).forEach(key => {
      if (!isObject(this[key]) || !this[key].hasOwnProperty('content') || !this[key].hasOwnProperty('fieldName')) return;
      let fieldName = isFunction(this[key].getValidationFieldName) ? this[key].getValidationFieldName() : this[key].fieldName;
      if (this[key].hasOwnProperty('messages')) {
        var _messages$fieldName;
        this[key].messages = (_messages$fieldName = messages[fieldName]) !== null && _messages$fieldName !== void 0 ? _messages$fieldName : [];
        messages[fieldName] = [];
      }
      if (this[key].content instanceof Form && isFunction(this[key].content.setValidationMessages)) {
        this[key].content.setValidationMessages(getMessagesKeyFirstPartRemoved(messages, fieldName));
      } else if (Array.isArray(this[key].content)) {
        this[key].content.forEach((item, i) => {
          if (!(item instanceof Form)) return;
          item.setValidationMessages(getMessagesKeyFirstPartRemoved(messages, [fieldName, i].join('.')));
        });
      }
    });
    return this;
  }
  scrollToUnvalidatedField() {
    var _field$validationScro;
    let fieldKey = Object.keys(this).find(formKey => {
      var _this$formKey$message;
      return this[formKey].id && this[formKey].isVisible && this[formKey].isVisible() && ((_this$formKey$message = this[formKey].messages) === null || _this$formKey$message === void 0 ? void 0 : _this$formKey$message.length) > 0;
    });
    let field = this[fieldKey];
    if (!field) return;
    this.scrollTo(field.id, (_field$validationScro = field.validationScrollParentNumber) !== null && _field$validationScro !== void 0 ? _field$validationScro : 2);
    return this;
  }
  scrollTo(id, parentNumber = 0) {
    let target = document.getElementById(id);
    if (!target) return this;
    target = Array.from({
      length: parentNumber
    }).reduce(target => {
      var _target$parentElement;
      return (_target$parentElement = target.parentElement) !== null && _target$parentElement !== void 0 ? _target$parentElement : target;
    }, target);
    target.scrollIntoView({
      block: "start",
      inline: "nearest",
      behavior: 'smooth'
    });
  }
  fieldHasErrors(field) {
    var _field$messages;
    let has_messages = (field === null || field === void 0 || (_field$messages = field.messages) === null || _field$messages === void 0 ? void 0 : _field$messages.length) > 0;
    let array_has_messages = false;
    let object_has_messages = false;
    if (Array.isArray(field)) array_has_messages = field.some(sf => this.fieldHasErrors(sf));
    if (isObject(field)) object_has_messages = Object.keys(field).some(k => this.fieldHasErrors(field[k]));
    return has_messages || array_has_messages || object_has_messages;
  }
  hasValidationErrors() {
    return Object.keys(this).some(k => {
      var _this$k$messages;
      let hasFormErrors = this[k].content instanceof Form ? this[k].content.hasValidationErrors() : Array.isArray(this[k].content) ? this[k].content.some(form => form instanceof Form && form.hasValidationErrors()) : false;
      return hasFormErrors || ((_this$k$messages = this[k].messages) === null || _this$k$messages === void 0 ? void 0 : _this$k$messages.length);
    });
  }
  getValidationErrors() {
    return Object.keys(this).reduce((init, next) => {
      var _this$next$messages;
      let contentValidationErrors = isFunction(this[next].getValidationErrors) ? this[next].getValidationErrors() : [];
      return init.concat((_this$next$messages = this[next].messages) !== null && _this$next$messages !== void 0 ? _this$next$messages : []).concat(contentValidationErrors);
    }, []);
  }
  getFirstValidationError() {
    var _this$getValidationEr;
    return (_this$getValidationEr = this.getValidationErrors()) === null || _this$getValidationEr === void 0 ? void 0 : _this$getValidationEr[0];
  }
  populateForm(data, keyType = 'mk') {
    if (!data) return this;
    Object.keys(this).forEach(formK => {
      var _data$formK, _data$formK$content, _data$formK2, _this$formK$default, _content, _this$formK$events;
      if (!isFunction(this[formK].setContent)) return;
      let content = data;
      switch (keyType) {
        case 'mk':
          // model key
          content = this[formK].modelKey ? getValueByDotNotation(data, this[formK].modelKey) : data;
          break;
        case 'fk':
          // form key
          content = isFunction((_data$formK = data[formK]) === null || _data$formK === void 0 ? void 0 : _data$formK.customContent) ? data[formK].customContent() : (_data$formK$content = (_data$formK2 = data[formK]) === null || _data$formK2 === void 0 ? void 0 : _data$formK2.content) !== null && _data$formK$content !== void 0 ? _data$formK$content : null;
          break;
        case 'fn':
          let fn = this[formK].fieldName;
          content = isObject(data) && data.hasOwnProperty(fn) ? data[fn] : isFunction(this[formK].default) ? this[formK].default() : (_this$formK$default = this[formK].default) !== null && _this$formK$default !== void 0 ? _this$formK$default : null;
          break;
        default:
      }
      this[formK].setContent((_content = content) !== null && _content !== void 0 ? _content : null, data[formK], keyType);
      if (isFunction((_this$formK$events = this[formK].events) === null || _this$formK$events === void 0 ? void 0 : _this$formK$events.OnChange)) this[formK].events.OnChange({
        fireChangeEvent: false
      });
    });
    return this;
  }

  // other is other data passed to setContent
  populateFields(data, dataMatchingKeyType = 'mk', other = {}) {
    if (!isObject(data)) return this;
    Object.keys(this).forEach(fieldKey => {
      //console.log('field before', fieldKey)

      if (!isFunction(this[fieldKey].setContent) || !dataMatchingKeyType || !this[fieldKey].hasOwnProperty('fieldName') && dataMatchingKeyType === 'fn') return;

      //console.log('field after', fieldKey)

      let content = null;
      switch (dataMatchingKeyType) {
        case "mk":
          content = this[fieldKey].hasOwnProperty('modelKey') ? getValueByDotNotation(data, this[fieldKey].modelKey) : data;
          break;
        case "fn":
          if (!data.hasOwnProperty(this[fieldKey].fieldName)) return;
          content = data[this[fieldKey].fieldName];
      }

      //console.log('field model key', this[fieldKey].modelKey)
      //console.log('field data', data)
      //console.log('field content', content)
      if (content !== undefined) {
        var _this$fieldKey$events;
        this[fieldKey].setContent(content, data[fieldKey], dataMatchingKeyType, other);
        if (isFunction((_this$fieldKey$events = this[fieldKey].events) === null || _this$fieldKey$events === void 0 ? void 0 : _this$fieldKey$events.OnChange)) this[fieldKey].events.OnChange({
          fireChangeEvent: false
        });
      }
    });
    return this;
  }
  populateDraftedFields(data) {
    if (!isObject(data)) return this;
    Object.keys(this).forEach(fieldKey => {
      if (!isFunction(this[fieldKey].setContent) && !isFunction(this[fieldKey].setDraftedContent)) return;
      let content = null;
      if (!data.hasOwnProperty(this[fieldKey].fieldName)) return;
      content = data[this[fieldKey].fieldName];
      if (isFunction(this[fieldKey].setDraftedContent)) {
        this[fieldKey].setDraftedContent(content);
        return;
      }
      this[fieldKey].setContent(content, data[fieldKey], 'fn');
    });
    return this;
  }
  emptyFormFields() {
    Object.keys(this).forEach(formField => {
      if (!isObject(this[formField]) || !this[formField].hasOwnProperty('content')) {
        return;
      }
      if (this[formField].hasOwnProperty('default')) {
        if (isFunction(this[formField].default)) {
          this[formField].default();
          return;
        }
        this[formField].content = this[formField].default;
        return;
      }
      this[formField].content = null;
    });
    return this;
  }
  static reBuildForm(form) {
    if (!isObject(form)) return null;
    let newForm = new this();
    Object.keys(newForm).forEach(fieldKey => {
      let newFormField = newForm[fieldKey];
      let newFormFieldName = newFormField.fieldName;
      let formContent = form === null || form === void 0 ? void 0 : form[newFormFieldName];
      if (formContent) {
        if (isFunction(newFormField.setContent)) newFormField.setContent(formContent, null, 'fn');else newFormField.content = formContent;
      }
    });
    return newForm;
  }
  canBeDisplayed(fieldId) {
    return this.id === fieldId && this.enumerable !== false;
  }
  populateDraftedForm(drafted) {
    if (!isObject(drafted)) return;
    Object.keys(this).forEach(key => {
      var _this$key2;
      if (isFunction((_this$key2 = this[key]) === null || _this$key2 === void 0 ? void 0 : _this$key2.populateDraftedData)) {
        var _drafted$key, _drafted$this$key$fie;
        let drafted_content = drafted === null || drafted === void 0 || (_drafted$key = drafted[key]) === null || _drafted$key === void 0 ? void 0 : _drafted$key.content;
        drafted_content = drafted_content === undefined ? (_drafted$this$key$fie = drafted[this[key].fieldName]) !== null && _drafted$this$key$fie !== void 0 ? _drafted$this$key$fie : null : drafted_content;
        /*console.log('key', key)
        console.log('drafted', drafted)*/
        this[key].populateDraftedData(drafted_content);
      }
    });
  }
  isFormDirty(pageModel, isEnabled = true) {
    let isDirty = false;
    if (!pageModel) return isDirty;
    Object.keys(this).forEach(formKey => {
      if (!this[formKey].dirtinessCheckable) return;
      let fieldDirty = this[formKey].checkDirtiness(get(pageModel, this[formKey].modelKey, pageModel), isEnabled);
      isDirty = isDirty || fieldDirty;
    });
    return isDirty;
  }
  isDirty() {
    return Object.keys(this).some(formKey => {
      let field = this[formKey];
      if (!field.dirtinessCheckable) {
        return false;
      }
      if (field.content instanceof Form) {
        return field.content.isDirty();
      }
      return this[formKey].isDirty;
    });
  }
  syncAllFields(params) {
    Object.keys(this).forEach(fieldKey => {
      var _this$fieldKey;
      let fieldEvent = (_this$fieldKey = this[fieldKey]) === null || _this$fieldKey === void 0 || (_this$fieldKey = _this$fieldKey.events) === null || _this$fieldKey === void 0 ? void 0 : _this$fieldKey.onChange;
      if (isFunction(fieldEvent) && (params === null || params === void 0 ? void 0 : params.fireChangeEvent) !== false) fieldEvent({
        value: this[fieldKey].content,
        inputChange: false,
        ...params
      });
    });
    return this;
  }
  callFieldEvent(field, eventNames = ['*'], eventArgs = {}) {
    if (!isObject(field) || !field.hasOwnProperty('events') || !isObject(field.events)) return;
    if (eventNames === ['*']) {
      eventNames = Object.keys(field.events);
    }
    eventNames.forEach(eventName => {
      if (!isFunction(field.events[eventName])) return;
      field.events[eventName]({
        value: field.content,
        isCalledByInput: false,
        ...eventArgs
      });
    });
  }
  callFieldsEvents(eventArgs, eventNames = ['*']) {
    Object.keys(this).forEach(fieldKey => {
      this.callFieldEvent(this[fieldKey], eventNames, eventArgs);
    });
  }
  callFieldsChangeEvent(eventArgs) {
    this.callFieldsEvents(eventArgs, ['onChange']);
  }
  async draftModel(modelId, className) {
    await store.dispatch('draftObject', {
      name: className,
      formObject: this,
      selected_id: modelId
    });
  }
  async deleteDraftedModel(modelId, className) {
    await store.dispatch('deleteDraftObject', {
      name: className,
      id: modelId
    });
  }
  populateDrafted(model) {
    let modelId = model instanceof Model || model instanceof JsonMappedModel ? model.getId() : null;
    let draftedObject = store.getters.getDraftedObject(this.constructor, modelId);
    //return this.populateForm(draftedObject ?? model, draftedObject ? 'fn' : 'mk')
    return draftedObject ? this.populateDraftedFields(draftedObject) : this.populateFields(model);
  }
  createRequestQuery() {
    return Object.keys(this).filter(k => this[k].fieldName && ![null, undefined].includes(this[k].content)).reduce((init, k) => {
      return [[init, this[k].fieldName].join(init === '?' ? '' : '&'), this[k].content].join('=');
    }, '?');
  }
  hasVisibleFields() {
    return Object.keys(this).some(fieldKey => isFunction(this[fieldKey].isVisible) && this[fieldKey].isVisible());
  }
}
_defineProperty(Form, "EDIT_MODE", 'edit-mode');
_defineProperty(Form, "CREATE_MODE", 'create-mode');